import { useState } from 'react';
import styled from 'styled-components';
import ContentHubTeaserCardDynamic from './ContentHubTeaserCardDynamic';
import Icon from '../../../atoms/Icon';

const NavigationButton = styled(Icon)`
  width: 16px;
  height: 14px;
  fill: ${(props) => props.theme.color.primary800} !important;
  transform: ${(props) =>
    props.direction === 'prev' ? 'rotate(180deg)' : 'none'};
`;

const Navigation = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin: 15px 0;
`;

const NavigationButtonWrapper = styled.button`
  cursor: pointer;
  width: 33px;
  height: 33px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 1px solid ${(props) => props.theme.color.gray400};
  background-color: ${(props) => props.theme.color.white500};
  &:hover {
    background-color: ${(props) => props.theme.color.gray500};
  }
  margin: 1px;
`;

/**
 * @param {ContentHubTeaserDynamicMobileProps} props
 * @returns {React.ReactElement} The rendered component
 */
export default function ContentHubTeaserDynamicMobile({
  teaser,
  setNextTeaser,
  setPrevTeaser,
}) {
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // the required distance between touchStart and touchEnd to be detected as a swipe
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    // @ts-ignore
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    if (isLeftSwipe) {
      setNextTeaser();
    }
    if (isRightSwipe) {
      setPrevTeaser();
    }
  };

  return (
    <div
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <ContentHubTeaserCardDynamic
        key={teaser.id}
        format={'square'}
        withDescription={false}
        isSelected
        {...teaser}
      />
      <Navigation>
        <NavigationButtonWrapper onClick={setPrevTeaser}>
          <NavigationButton icon="ARROW_CTA" direction={'prev'} />
        </NavigationButtonWrapper>
        <NavigationButtonWrapper onClick={setNextTeaser}>
          <NavigationButton icon="ARROW_CTA" direction={'next'} />
        </NavigationButtonWrapper>
      </Navigation>
    </div>
  );
}
